import React, { createContext, useContext, useState, ReactNode } from 'react';

export enum SettingsPage {
  myProfile = 'My Profile',
  notifications = 'Notifications',
  inviteDependents = 'Invite Dependents',
  changePassword = 'Change Password',
  myPlan = 'My Plan',
  paymentMethod = 'Payment Method',
  callHistory = 'Call History',
  myFavorites = 'My Favorites',
  aboutUs = 'About us',
  privacyPolicy = 'Privacy Policy',
  termsOfUse = 'Terms of Use',
}

interface SettingsModalContextProps {
  isModalOpen: boolean;
  selectedPage: SettingsPage | undefined;
  openModal: (page?: SettingsPage) => void;
  closeModal: () => void;
}

const SettingsModalContext = createContext<SettingsModalContextProps | undefined>(undefined);

export const SettingsModalProvider = ({ children }: { children: ReactNode }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPage, setSelectedPage] = useState<SettingsPage | undefined>(undefined);

  const openModal = (page?: SettingsPage) => {
    setIsModalOpen(true);
    setSelectedPage(page);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPage(undefined);
  };

  return (
    <SettingsModalContext.Provider value={{ isModalOpen, selectedPage, openModal, closeModal }}>
      {children}
    </SettingsModalContext.Provider>
  );
};

export const useSettingsModal = () => {
  const context = useContext(SettingsModalContext);
  if (!context) {
    throw new Error('useSettingsModal must be used within a SettingsModalProvider');
  }
  return context;
};
